export const TwoFaModalIllustration = () => (
  <svg
    width='480'
    height='352'
    viewBox='0 0 480 352'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect y='122' width='480' height='230' rx='20' fill='#F4F4F5' />
    <rect x='320.5' y='255.5' width='63' height='33' rx='16.5' fill='#2186AB' />
    <rect
      x='320.5'
      y='255.5'
      width='63'
      height='33'
      rx='16.5'
      stroke='#2186AB'
    />
    <rect x='354' y='259' width='26' height='26' rx='13' fill='white' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M344.199 266.153C344.714 266.477 344.863 267.149 344.533 267.653L338.548 276.798C337.52 278.368 335.211 278.458 334.059 276.972L331.497 273.666C331.127 273.189 331.222 272.508 331.709 272.145C332.196 271.782 332.891 271.875 333.262 272.353L335.824 275.659C336.044 275.943 336.486 275.926 336.683 275.625L342.668 266.481C342.998 265.976 343.684 265.83 344.199 266.153Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M49.3934 158.087C49.1382 158.001 48.8622 158.001 48.607 158.087L38.407 161.501C37.902 161.67 37.5616 162.143 37.5616 162.676V171.787C37.5616 176.383 39.9205 180.658 43.809 183.108L48.3399 185.963C48.7434 186.217 49.257 186.217 49.6605 185.963L54.1914 183.108C58.0799 180.658 60.4388 176.383 60.4388 171.787V162.676C60.4388 162.143 60.0984 161.67 59.5934 161.501L49.3934 158.087ZM47.8515 155.83C48.597 155.58 49.4035 155.58 50.1489 155.83L60.3489 159.244C61.8243 159.738 62.8188 161.12 62.8188 162.676V171.787C62.8188 177.201 60.0404 182.235 55.4603 185.122L50.9294 187.977C49.7505 188.72 48.2499 188.72 47.071 187.977L42.5402 185.122C37.96 182.235 35.1816 177.201 35.1816 171.787V162.676C35.1816 161.12 36.1761 159.738 37.6515 159.244L47.8515 155.83Z'
      fill='#2186AB'
    />
    <path
      d='M49.9374 165.845C49.5965 164.985 48.4031 164.985 48.0622 165.845L47.0264 168.459C47.0002 168.525 46.9391 168.57 46.8692 168.575L44.1132 168.773C43.2062 168.838 42.8374 169.996 43.5338 170.593L45.6496 172.405C45.7033 172.451 45.7266 172.525 45.7096 172.594L45.0422 175.33C44.8225 176.23 45.788 176.946 46.5592 176.454L48.9026 174.961C48.9621 174.923 49.0375 174.923 49.097 174.961L51.4405 176.454C52.2117 176.946 53.1772 176.23 52.9575 175.33L52.29 172.594C52.2731 172.525 52.2964 172.451 52.3501 172.405L54.4659 170.593C55.1622 169.996 54.7934 168.838 53.8864 168.773L51.1305 168.575C51.0605 168.57 50.9995 168.525 50.9732 168.459L49.9374 165.845Z'
      fill='#2186AB'
    />
    <path
      opacity='0.5'
      d='M41 250H157'
      stroke='black'
      strokeWidth='10'
      strokeLinecap='round'
    />
    <line
      opacity='0.5'
      x1='83'
      y1='173'
      x2='241'
      y2='173'
      stroke='#1D739B'
      strokeWidth='18'
      strokeLinecap='round'
    />
    <path
      opacity='0.5'
      d='M41 272L187 272'
      stroke='#898989'
      strokeWidth='10'
      strokeLinecap='round'
    />
    <path
      opacity='0.5'
      d='M41 292H106'
      stroke='#898989'
      strokeWidth='10'
      strokeLinecap='round'
    />
    <path
      opacity='0.5'
      d='M400 272H448'
      stroke='#898989'
      strokeWidth='10'
      strokeLinecap='round'
    />
    <g opacity='0.15' clipPath='url(#clip0_2105_115841)'>
      <path
        d='M346.414 235.058C342.366 231.306 338.504 227.48 335.131 223.263C331.691 218.876 328.808 214.269 326.415 209.272C324.021 204.275 322.37 198.986 320.973 193.795C319.761 188.532 319.055 183.465 318.231 178.643C317.642 175.509 319.685 172.528 322.976 171.63C326.267 170.732 329.574 172.599 330.348 175.66C331.56 180.923 332.384 185.746 333.698 190.178C334.894 194.854 336.579 199.14 338.753 203.035C339.815 205.191 340.995 207.102 342.429 209.112L342.412 208.525C342.718 203.852 342.4 199.226 342.335 194.699C342.203 190.001 342.138 185.474 341.449 180.994L340.693 174.166C340.441 171.889 340.375 169.54 339.752 167.41C337.113 149.248 331.739 131.765 324.577 115.183C322.892 110.897 320.717 107.001 318.661 102.862C316.79 98.6487 314.244 94.8992 311.884 91.0767C307.095 83.2603 301.632 75.9073 295.865 68.8718C294.499 67.0335 292.829 65.5127 291.278 63.7475L286.691 58.6232L281.749 54.2321C280.079 52.7113 278.342 51.0191 276.554 49.7427L271.174 45.3262C269.318 43.8784 267.345 42.675 265.489 41.2272C261.778 38.3316 257.713 36.1692 253.766 33.7625L253.445 33.4926C252.045 32.6575 251.489 30.6987 252.384 29.1591C253.398 27.3751 255.693 26.6706 257.346 27.6041C266.473 31.7352 275.06 36.6727 282.987 42.6608C285.028 44.0357 286.951 45.6549 288.807 47.1027L294.508 51.7891L299.719 56.8658C301.456 58.5581 303.379 60.1773 304.745 62.0156C311.204 69.175 317.426 76.8233 322.72 84.8366C325.401 88.9289 328.015 92.8498 330.138 97.1612C332.448 101.4 334.943 105.565 336.696 110.022C340.758 118.718 343.891 127.779 346.839 136.912C348.035 141.589 349.416 146.192 350.426 150.941L353.016 165.164C353.521 167.538 353.588 169.888 353.907 172.335L354.612 179.58C355.183 184.304 355.197 189.247 355.329 193.945C355.327 198.301 355.696 202.51 355.44 206.767C357.975 201.218 360.576 195.841 362.857 190.193C365.561 183.984 368.011 177.676 370.208 171.27C372.22 164.937 374.164 158.433 375.18 152.293C375.552 149.969 377.696 148.335 380.076 148.389C382.641 148.37 384.513 150.405 384.393 152.827C383.782 159.996 382.225 166.941 380.602 173.716C378.792 180.563 376.662 187.141 374.347 193.791C372.031 200.442 369.649 206.921 367.013 213.302C364.444 219.854 361.808 226.235 358.801 232.761L358.683 233.006C358.328 233.739 357.906 234.301 357.298 234.936C353.803 237.497 349.365 237.659 346.414 235.058Z'
        fill='#2186AB'
      />
    </g>
    <defs>
      <clipPath id='clip0_2105_115841'>
        <rect
          width='231'
          height='79'
          fill='white'
          transform='matrix(0.365904 0.930652 0.930652 -0.365904 251 28.9062)'
        />
      </clipPath>
    </defs>
  </svg>
)
